import { memo } from "react";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage, FormattedPlural } from "react-intl";
import PropTypes from "prop-types";

const LayoverCountDisplay = ({ count }) => {
	return count > 0 ? (
		<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} className="stop-duration" isBold>
			<FormattedPlural
				value={count}
				one={
					<FormattedMessage
						values={{
							value: count,
						}}
						id="general.stop.singular"
					/>
				}
				other={
					<FormattedMessage
						values={{
							value: count,
						}}
						id="general.stop.plural"
					/>
				}
			/>
		</Typography>
	) : (
		<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} className="stop-duration" isBold>
			<FormattedMessage id="general.transport.direct" />
		</Typography>
	);
};

LayoverCountDisplay.propTypes = {
	count: PropTypes.number.isRequired,
};

export default memo(LayoverCountDisplay);
